"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Input = function Input(props) {
	var wrapperClass = props.wrapperClass,
	    label = props.label,
	    rest = _objectWithoutProperties(props, ["wrapperClass", "label"]);

	return _react2.default.createElement(
		"div",
		{ className: "input-wrapper " + wrapperClass },
		label ? _react2.default.createElement(
			"label",
			{ htmlFor: "" },
			label
		) : null,
		_react2.default.createElement("input", rest)
	);
};

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/form/Input.js
// module id = 569
// module chunks = 0